// Copyright (c) 2017 Deere & Company

export default [
    {
        displayName: 'REIMBURSEMENT_PERCENTAGE',
        path: ['reimbursementDetails', 'reimbursementPercentage']
    },
    {
        displayName: 'UPDATED',
        path: ['updatedOn']
    },
    {
        displayName: 'APPROVED',
        path: ['reimbursementDetails', 'approvedAmount']
    },
    {
        displayName: 'REQUESTED',
        path: ['reimbursementDetails', 'requestedAmount']
    },
    {
        displayName: 'WITH_ADDITIVES',
        path: ['reimbursementDetails', 'withAdditives']
    }
];



// WEBPACK FOOTER //
// ./src/tcsm/claim-search/constants/sort-options.js